import {
  Person as PatientIcon,
  LocalHospital as DoctorIcon,
  Description as ProtocolIcon,
} from "@mui/icons-material";
import { Box, Card, Grid, Skeleton, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useQuickStats } from "@/services/hooks/useQuickStats";

export function QuickStats() {
  const { stats } = useQuickStats();
  const theme = useTheme();
  const navigate = useNavigate();

  const statsConfig = [
    {
      label: "Total de pacientes da sua clínica",
      value: stats.patients.total,
      icon: <PatientIcon />,
      color: theme.palette.primary.main,
      loading: stats.patients.loading,
      path: "/",
      state: { tabIndex: 1, viewType: "admin" },
    },
    {
      label: "Total de profissionais ativos",
      value: stats.doctors.total,
      icon: <DoctorIcon />,
      color: theme.palette.success.main,
      loading: stats.doctors.loading,
      path: "/practitioners",
    },
    {
      label: "Protocolos clínicos ativos",
      value: stats.protocols.total,
      icon: <ProtocolIcon />,
      color: theme.palette.info.main,
      loading: stats.protocols.loading,
      path: "/manageprotocol",
    },
  ];

  return (
    <Grid container width="100%" spacing={1.5}>
      {statsConfig.map((stat, index) => (
        <Grid
          item
          xs={12}
          sm={4}
          key={stat.label}
          sx={{
            "& .MuiCard-root": { height: "100%" },
            ...(index === 0 && { paddingLeft: "0px !important" }),
          }}
        >
          <Card
            sx={{
              p: 1.5,
              height: "100%",
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              bgcolor: stat.loading ? "transparent" : "background.paper",
              border: "1px solid",
              borderColor: stat.loading ? "divider" : `${stat.color}30`,
              cursor: "pointer",
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                borderColor: stat.color,
                boxShadow: 1,
              },
            }}
            onClick={() => navigate(stat.path, { state: stat.state })}
          >
            {stat.loading ? (
              <Skeleton variant="rounded" width={44} height={44} sx={{ borderRadius: 1.5 }} />
            ) : (
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: 1.5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  bgcolor: `${stat.color}15`,
                  color: stat.color,
                  flexShrink: 0,
                  "& > svg": { fontSize: 24 },
                }}
              >
                {stat.icon}
              </Box>
            )}
            <Box sx={{ flex: 1, minWidth: 0 }}>
              {stat.loading ? (
                <>
                  <Skeleton variant="text" width="50%" height={36} />
                  <Skeleton variant="text" width="80%" height={20} />
                </>
              ) : (
                <>
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{
                      fontWeight: 800,
                      color: stat.color,
                      lineHeight: 1.1,
                      fontVariantNumeric: "tabular-nums",
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontWeight: 500, mt: 0.25, lineHeight: 1.3 }}
                  >
                    {stat.label}
                  </Typography>
                </>
              )}
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
